import React from 'react';

import { useAuth } from 'contexts/auth';
import ChatProvider from 'contexts/chat';
import TaskProvider from 'contexts/task';
import UserProvider from 'contexts/user';
import UserProvider2 from 'contexts/user2';
import ViewportProvider from 'contexts/viewport';
import WebsocketProvider from 'contexts/websocket';
import TourProvider from 'contexts/tour';
import RoleProvider from 'hoc/withRoleProvider';

const ProviderWrapper = ({ children }) => {
    const { auth } = useAuth();

    return (
        <ViewportProvider>
            {auth ? (
                <WebsocketProvider>
                    <UserProvider>
                        <UserProvider2>
                            <RoleProvider auth={auth}>
                                <TaskProvider>
                                    <ChatProvider>
                                        <TourProvider>{children}</TourProvider>
                                    </ChatProvider>
                                </TaskProvider>
                            </RoleProvider>
                        </UserProvider2>
                    </UserProvider>
                </WebsocketProvider>
            ) : (
                children
            )}
        </ViewportProvider>
    );
};

export default ProviderWrapper;
